module.exports = __webpack_public_path__ + "static/media/Card_Tick.0e23c7bd.svg";